import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';

function initHeroCarousels() {
    // Dev escape hatch: append ?pause-hero=1 (or N to lock to slide N) to freeze
    // the carousel on a specific slide for design comparison.
    const params = new URLSearchParams(window.location.search);
    const paused = params.has('pause-hero');
    const slideIdx = paused ? Math.max(0, parseInt(params.get('pause-hero'), 10) || 0) : null;

    document.querySelectorAll('.hero-swiper').forEach((el) => {
        if (el.swiper) return;

        const section = el.closest('.hero-carousel');
        if (!section) return;

        new Swiper(el, {
            modules: [Autoplay, Pagination],
            slideClass: 'hero-slide-block',
            loop: !paused,
            speed: 600,
            initialSlide: slideIdx ?? 0,
            autoplay: paused ? false : {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: section.querySelector('.hero-pagination'),
                clickable: true,
                bulletClass: 'hero-bullet',
                bulletActiveClass: 'hero-bullet--active',
                renderBullet(index, className) {
                    return `<button class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
                },
            },
        });

        // Reveal after Swiper is ready
        section.classList.add('swiper-ready');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCarousels);
} else {
    initHeroCarousels();
}
